import React, { useEffect, useState } from "react";
import api from "../../lib/api";
import { Mail, Phone, MapPin } from "lucide-react";

export default function PublicContact() {
    const [club, setClub] = useState(null);
    useEffect(() => { api.get("/public/clubs/by-name/ASSMBB").then((r) => setClub(r.data)); }, []);

    return (
        <section className="max-w-7xl mx-auto px-6 lg:px-12 py-16" data-testid="public-contact-page">
            <div className="text-xs uppercase tracking-[0.3em] text-orange-500 font-bold mb-3">Contact</div>
            <h1 className="font-display text-4xl lg:text-5xl font-black mb-10">Rejoindre {club?.name || "le club"}</h1>

            <div className="grid lg:grid-cols-2 gap-12">
                <div className="space-y-4">
                    <p className="text-slate-700 max-w-md">{club?.description}</p>
                    {club?.history && <p className="text-slate-600 max-w-md">{club.history}</p>}

                    <div className="bg-white border border-slate-200 rounded-xl p-6 space-y-3 max-w-md">
                        <div className="flex items-center gap-3">
                            <Mail className="w-5 h-5 text-orange-500" />
                            <a href={`mailto:${club?.email}`} className="text-slate-700 hover:text-orange-500">{club?.email}</a>
                        </div>
                        <div className="flex items-center gap-3">
                            <Phone className="w-5 h-5 text-orange-500" />
                            <span className="text-slate-700">{club?.phone}</span>
                        </div>
                        <div className="flex items-center gap-3">
                            <MapPin className="w-5 h-5 text-orange-500" />
                            <span className="text-slate-700">{club?.address}</span>
                        </div>
                    </div>
                </div>

                <form onSubmit={(e) => { e.preventDefault(); alert("Merci ! Votre message a été envoyé (formulaire de démo)."); }} className="bg-white border border-slate-200 rounded-xl p-6 space-y-4" data-testid="contact-form">
                    <h3 className="font-display text-xl font-bold">Envoyer un message</h3>
                    <input className="w-full rounded-lg border border-slate-200 px-3 py-2 text-sm" placeholder="Votre nom" required />
                    <input type="email" className="w-full rounded-lg border border-slate-200 px-3 py-2 text-sm" placeholder="Email" required />
                    <input className="w-full rounded-lg border border-slate-200 px-3 py-2 text-sm" placeholder="Sujet" />
                    <textarea rows={5} className="w-full rounded-lg border border-slate-200 px-3 py-2 text-sm" placeholder="Votre message…" required />
                    <button className="inline-flex items-center bg-orange-500 hover:bg-orange-600 text-white font-semibold rounded-lg px-5 py-2 text-sm transition-colors">Envoyer</button>
                </form>
            </div>
        </section>
    );
}
